import type { QtyField, SettingField } from "~/utils/allocationLineSettings"

/** The dialog's tabs: store exclusions, then one per quantity. */
export type DialogTab = "stores" | QtyField

type SettingFieldMeta = {
  header: string
  filterName: string
  label: string
  tab: DialogTab
  tabLabel: string
  /** The count square's tooltip: "<squareLabel>: 3 cells <squareVerb>". */
  squareLabel: string
  squareVerb: string
  tone: string
  squareTone: string
}

export const SETTING_FIELD_META: Record<SettingField, SettingFieldMeta> = {
  excluded: {
    header: "Location exclusions",
    filterName: "Location exclusions",
    label: "Store",
    tab: "stores",
    tabLabel: "Stores",
    squareLabel: "Store exclusions",
    squareVerb: "excluded",
    tone: "text-badge-orange-fg-text",
    squareTone: "border-badge-orange-border bg-badge-orange-bg text-badge-orange-fg-text",
  },
  minDisplayQty: {
    header: "Minimum display quantity",
    filterName: "Minimum display quantity (cells set)",
    label: "Minimum display quantity",
    tab: "minDisplayQty",
    tabLabel: "Minimum display quantity",
    squareLabel: "Minimum display quantity",
    squareVerb: "set",
    tone: "text-badge-blue-fg-text",
    squareTone: "border-badge-blue-border bg-badge-blue-bg text-badge-blue-fg-text",
  },
  maxQty: {
    header: "Maximum stock",
    filterName: "Maximum stock (cells set)",
    label: "Maximum stock",
    tab: "maxQty",
    tabLabel: "Maximum stock",
    squareLabel: "Maximum stock",
    squareVerb: "set",
    tone: "text-badge-primary-fg-text",
    squareTone: "border-badge-primary-border bg-badge-primary-bg text-badge-primary-fg-text",
  },
  orderMultiple: {
    header: "Order multiple",
    filterName: "Order multiple (cells set)",
    label: "Order multiple",
    tab: "orderMultiple",
    tabLabel: "Order multiple",
    squareLabel: "Order multiple",
    squareVerb: "set",
    tone: "text-badge-green-fg-text",
    squareTone: "border-badge-green-border bg-badge-green-bg text-badge-green-fg-text",
  },
}

export const fieldOfTab = (tab: DialogTab): SettingField => (tab === "stores" ? "excluded" : tab)

/** A saved or staged value as Details and the changelog show it. */
export function showSettingValue(field: SettingField, value: number | boolean | null | undefined) {
  if (field === "excluded") return value ? "Excluded" : "Included"
  return value === null || value === undefined ? "Not set" : `${value}`
}

/** "1,200 u", or "—" when uncapped. */
export function formatUnits(total: number | null) {
  return total === null ? "—" : `${total.toLocaleString("en")} u`
}

export const isSettingField = (id: string): id is SettingField =>
  Object.hasOwn(SETTING_FIELD_META, id)
